import React from "react";
import noDataPlaceholder from "../../assets/img/nodata_available.svg";

export interface InsightRow {
  label: string;
  delta: number;
  metric?: number | string;
}

interface Props {
  title: string;
  data: InsightRow[];
  deltaSuffix?: string;
  showMetricColumn?: boolean;
  metricHeader?: string;
}

const InsightTable: React.FC<Props> = ({
  title,
  data,
  deltaSuffix = "",
  showMetricColumn = true,
  metricHeader = "Metric"
}) => {
    const sortedData = data
  console.log("sortedData",sortedData)
  return (
    <div style={styles.card}>
      <h3 className="chart-headers" style={{margin: 0}}>{title}</h3>
      {sortedData.length === 0 ? (

      <div style={styles.noDataContainer}>
        <img
          src={noDataPlaceholder}
          alt="No Data"
          style={styles.noDataImage}
        />
      </div>
      ) : (
      sortedData.map((row) => {
        // const isNeutral = row.delta >= 0 && row.delta <= 1;
        // const isPositive = row.delta > 1;
        // const isNegative = row.delta < 0;

        return (
          <div key={row.label} style={styles.row}>
            <div style={styles.label}>{row.label}</div>

            <div
              style={{
                ...styles.deltaContainer,
                // color: isNeutral ? "#333" : isPositive ? "#2E7D32" : "#C62828"
                color: "#333"
              }}
            >
              {/*<div style={{backgroundColor: isNeutral ? "#E0E0E0" : isPositive ? "#C8E6C9" : "#FFCDD2", padding: "2px 6px", borderRadius: 4}}>*/}
              <div style={{backgroundColor:"#E0E0E0", padding: "2px 6px", borderRadius: 4}}>
                {/*<span style={styles.arrow}>*/}
                {/*  {isNeutral ? "●" : isPositive ? "▲" : "▼"}*/}
                {/*</span>*/}
                <span>
                  {row.delta}
                  {deltaSuffix}
                </span>
              </div>
            </div>

            {/*{showMetricColumn && (*/}
            {/*  <div style={styles.metric}>*/}
            {/*    {row.metric ?? "-"}*/}
            {/*  </div>*/}
            {/*)}*/}
          </div>
        );
      }))}
    </div>
  );
};

export default InsightTable;

const styles: { [key: string]: React.CSSProperties } = {
  card: {
    // background: "#ffffff",
    // borderRadius: 12,
    // padding: "20px 24px",
    // boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
    width: "100%",
    fontFamily: "$poppins"
  },
  row: {
    display: "flex",
    justifyContent:"space-between",
    alignItems: "center",
    padding: "4px 0px"
  },
  label: {
    fontSize: 13,
    color: "#333"
  },
  deltaContainer: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    fontSize: 13,
    fontWeight: 500
  },
  arrow: {
    fontSize: 11
  },
  metric: {
    textAlign: "right",
    fontSize: 13,
    color: "#444"
  },
  noDataContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  }
};
